/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Case_History_Headline_Documents_Classified_GroupInputs */

const en_case_history_headline_documents_classified_group = /** @type {(inputs: Case_History_Headline_Documents_Classified_GroupInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} files classified`)
};

const pt_br2_case_history_headline_documents_classified_group = /** @type {(inputs: Case_History_Headline_Documents_Classified_GroupInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} arquivos classificados`)
};

/**
* | output |
* | --- |
* | "{count} files classified" |
*
* @param {Case_History_Headline_Documents_Classified_GroupInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_history_headline_documents_classified_group = /** @type {((inputs: Case_History_Headline_Documents_Classified_GroupInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_History_Headline_Documents_Classified_GroupInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_history_headline_documents_classified_group(inputs)
	return pt_br2_case_history_headline_documents_classified_group(inputs)
});